<template>
    <!--
        Agency-status pill (different from deal-status pill in ui.jsx).
        Agencies have their own vocabulary: Active / Discontinued / Inactive /
        Waitlisted, mapped to OKLCH soft-bg + accent-fg combos from tokens.css.
    -->
    <span class="pill" :style="rootStyle">
        <span class="dot" />
        {{ label }}
    </span>
</template>

<script>
// Map agency-status label → CSS variable pair from tokens.css.
const MAP = {
    Active:       { bg: "var(--st-open-bg)",     fg: "var(--st-open-fg)" },
    Discontinued: { bg: "var(--st-overdue-bg)",  fg: "var(--st-overdue-fg)" },
    Inactive:     { bg: "var(--st-draft-bg)",    fg: "var(--st-draft-fg)" },
    Waitlisted:   { bg: "var(--st-hold-bg)",     fg: "var(--st-hold-fg)" },
};

export default {
    name: "AgencyPill",
    props: {
        status: { type: String, default: "" },
    },
    computed: {
        label() {
            return this.status || "—";
        },
        palette() {
            return MAP[this.status] || MAP.Inactive;
        },
        rootStyle() {
            return {
                background: this.palette.bg,
                color: this.palette.fg,
            };
        },
    },
};
</script>
